module.exports = __webpack_public_path__ + "static/media/tools-devmode.c0e860ea.svg";